/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Invalid_TokenInputs */

const nl_auth_api_errors_invalid_token = /** @type {(inputs: Auth_Api_Errors_Invalid_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig token`)
};

/**

* @param {Auth_Api_Errors_Invalid_TokenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_invalid_token = /** @type {((inputs?: Auth_Api_Errors_Invalid_TokenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Invalid_TokenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_invalid_token(inputs)
});
export { auth_api_errors_invalid_token as "auth.api_errors.invalid_token" }